import { action } from 'satcheljs';
import { Todo } from 'owa-todo-types';
import { LoadPanelDataConfig } from '../store/schema/LoadPanelDataConfig';
import { TodoListId } from '../store/schema/TodoListId';

/**
 * This action can be used to preload data in the task pane, or to load new data into
 * an already open/loaded task pane.
 * @param loadPanelDataConfig data about which tasks/ task folder should be loaded.
 * @param preLoadTasks specify tasks that should complete before the task pane data (tasks/ task folders) is loaded
 */
export const loadTaskPanelData = action(
    'PRE_LOAD_TODO_PANEL_DATA',
    (loadPanelDataConfig?: LoadPanelDataConfig, preLoadTasks?: Promise<any>[]) => ({
        loadPanelDataConfig,
        preLoadTasks,
    })
);

export const initializeQuickAdd = action(
    'initializeQuickAdd',
    (subject: string, linkedEmailEwsId?: string, extractionId?: string) => ({
        subject,
        linkedEmailEwsId,
        extractionId,
    })
);

/**
 * This switches the list to the list specified by listId. If there is no listId provided, and we can create tasks in the the currently selected list view,
 * then we do not switch folders. If we cannot create tasks in the current list view, we switch to the default
 * folder list view.
 */
export const switchListAndCreateTasks = action(
    'switchListAndCreateTasks',
    (todos: Partial<Todo>[], listId?: TodoListId) => ({
        todos,
        listId,
    })
);

export const clickTaskItem = action('clickTaskItem', (taskId: string) => ({
    taskId,
}));
